import baseTheme from '../baseTheme';
export var MuiInputLabel = {
    root: {
        // This is scaled up to deal with the transform applied in "notched" mode.
        fontSize: baseTheme.typography.pxToRem(18.5),
        letterSpacing: '0.02em',
        fontWeight: 700,
        overflow: 'visible',
        lineHeight: 1.5,
        color: baseTheme.palette.text.primary,
        '&.Mui-focused:not(.Mui-error)': {
            color: baseTheme.palette.text.primary,
        },
        '&.Mui-required': {
            '&::before': {
                content: '"*"',
                color: baseTheme.palette.error.main,
                position: 'relative',
                bottom: -4,
                fontSize: '1.25rem',
                lineHeight: '10px',
                fontWeight: 400,
                marginRight: baseTheme.spacing(0.5),
            },
            '&.Mui-disabled': {
                '&::before': {
                    color: baseTheme.palette.text.disabled,
                },
            },
        },
    },
    shrink: {
        '&&&': {
            transform: 'translate(14px, -11px) scale(0.75)',
        },
    },
    formControl: {},
    asterisk: {
        display: 'none',
    },
};
//# sourceMappingURL=MuiInputLabel.js.map